import apiSlice from "./apiSlice";
const fileUploadSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        fileUpload: builder.mutation({
            query: ({ file, projectId, type, baseline }) => {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("type", type);
                formData.append("baseline", baseline);
                if (projectId) {
                    formData.append("projectId", projectId);
                }

                return {
                    url: "/Files",
                    method: "POST",
                    body: formData,
                };
            },
        }),
        updateFileUpload: builder.mutation({
            query: (body) => ({
                url: `/Files`,
                method: 'PUT',
                body,
            }),

        }),
        getFileUploads: builder.query({
            query: (params) => ({
                url: "/files",
                params,
            }),
        }),
        getPendingFileUploads: builder.query({
            query: (params) => ({
                url: "/files/pending",
                params,
            }),
        }),
        getSubmittedByMeFileUploads: builder.query({
            query: (params) => ({
                url: "/files/GetSubmittedFiles",
                params,
            }),
        }),
        getfileUploadDetails: builder.query({
            query: (fileId) => ({
                url: `/Files/${fileId}`,
            }),
        }),
    }),
});

export const {
    useFileUploadMutation,
    useGetFileUploadsQuery,
    useGetPendingFileUploadsQuery,
    useGetSubmittedByMeFileUploadsQuery,
    useGetBulkUploadDetailsQuery,
    useUpdateFileUploadMutation
} = fileUploadSlice;
